<ng-template #titleTemplate>
  <ng-template [ngTemplateOutlet]="dwTitle"></ng-template>
</ng-template>
<ng-template #descriptionTemplate>
  <ng-template [ngTemplateOutlet]="dwDescription"></ng-template>
</ng-template>
<div class="ant-steps-item-tail" *ngIf="last !== true"></div>
<div class="ant-steps-item-icon">
  <ng-template [ngIf]="!showProcessDot">
    <span class="ant-steps-icon anticon anticon-check" *ngIf="dwStatus === 'finish' && !dwIcon"></span>
    <span class="ant-steps-icon anticon anticon-cross" *ngIf="dwStatus === 'error'"></span>
    <span class="ant-steps-icon" *ngIf="(dwStatus === 'process' || dwStatus === 'wait') && !dwIcon">{{ index + 1 }}</span>
    <span class="ant-steps-icon" *ngIf="dwIcon">
      <ng-container *ngIf="isIconString; else iconTemplate">
        <i [ngClass]="dwIcon"></i>
      </ng-container>
      <ng-template #iconTemplate>
      <ng-template [ngTemplateOutlet]="dwIcon"></ng-template>
    </ng-template>
    </span>
  </ng-template>
  <ng-template [ngIf]="showProcessDot">
    <span class="ant-steps-icon">
      <ng-template #processDotTemplate>
        <span class="ant-steps-icon-dot"></span>
      </ng-template>
      <ng-template [ngTemplateOutlet]="customProcessTemplate||processDotTemplate" [ngTemplateOutletContext]="{ $implicit: processDotTemplate, status:dwStatus, index:index }"></ng-template>
    </span>
  </ng-template>
</div>
<div class="ant-steps-item-content">
  <div class="ant-steps-item-title">
    <ng-container *ngIf="isTitleString; else titleTemplate">{{ dwTitle }}</ng-container>
  </div>
  <div class="ant-steps-item-description">
    <ng-container *ngIf="isDescriptionString; else descriptionTemplate">{{ dwDescription }}</ng-container>
  </div>
</div>